/** Country centroid coordinates [longitude, latitude] keyed by ISO 3166-1 alpha-2 code */
export const COUNTRY_CENTROIDS: Record<string, [number, number]> = {
  AD: [1.52, 42.55],
  AE: [53.85, 23.42],
  AF: [67.71, 33.94],
  AG: [-61.80, 17.06],
  AI: [-63.07, 18.22],
  AL: [20.17, 41.15],
  AM: [45.04, 40.07],
  AO: [17.87, -11.20],
  AQ: [0.00, -75.25],
  AR: [-63.62, -38.42],
  AS: [-170.13, -14.27],
  AT: [14.55, 47.52],
  AU: [133.78, -25.27],
  AW: [-69.97, 12.51],
  AX: [19.95, 60.18],
  AZ: [47.58, 40.14],
  BA: [17.68, 43.92],
  BB: [-59.54, 13.19],
  BD: [90.36, 23.68],
  BE: [4.47, 50.50],
  BF: [-1.56, 12.24],
  BG: [25.49, 42.73],
  BH: [50.56, 26.07],
  BI: [29.92, -3.37],
  BJ: [2.32, 9.31],
  BL: [-62.83, 17.90],
  BM: [-64.75, 32.32],
  BN: [114.73, 4.54],
  BO: [-63.59, -16.29],
  BQ: [-68.26, 12.18],
  BR: [-51.93, -14.24],
  BS: [-77.40, 25.03],
  BT: [90.43, 27.51],
  BV: [3.41, -54.42],
  BW: [24.68, -22.33],
  BY: [27.95, 53.71],
  BZ: [-88.50, 17.19],
  CA: [-106.35, 56.13],
  CC: [96.87, -12.16],
  CD: [21.76, -4.04],
  CF: [20.94, 6.61],
  CG: [15.83, -0.23],
  CH: [8.23, 46.82],
  CI: [-5.55, 7.54],
  CK: [-159.78, -21.24],
  CL: [-71.36, -35.68],
  CM: [12.35, 7.37],
  CN: [104.20, 35.86],
  CO: [-74.30, 4.57],
  CR: [-83.75, 9.75],
  CU: [-77.78, 21.52],
  CV: [-24.01, 16.00],
  CW: [-68.99, 12.17],
  CX: [105.69, -10.45],
  CY: [33.43, 35.13],
  CZ: [15.47, 49.82],
  DE: [10.45, 51.17],
  DJ: [42.59, 11.83],
  DK: [9.50, 56.26],
  DM: [-61.37, 15.41],
  DO: [-70.16, 18.74],
  DZ: [1.66, 28.03],
  EC: [-78.18, -1.83],
  EE: [25.01, 58.60],
  EG: [30.80, 26.82],
  EH: [-12.89, 24.22],
  ER: [39.78, 15.18],
  ES: [-3.75, 40.46],
  ET: [40.49, 9.15],
  FI: [25.75, 61.92],
  FJ: [179.41, -16.58],
  FK: [-59.35, -51.80],
  FM: [150.55, 7.43],
  FO: [-6.91, 61.89],
  FR: [2.21, 46.23],
  GA: [11.61, -0.80],
  GB: [-3.44, 55.38],
  GD: [-61.60, 12.26],
  GE: [43.36, 42.32],
  GF: [-53.13, 3.93],
  GG: [-2.59, 49.47],
  GH: [-1.02, 7.95],
  GI: [-5.35, 36.14],
  GL: [-42.60, 71.71],
  GM: [-15.31, 13.44],
  GN: [-9.70, 9.95],
  GP: [-61.55, 16.00],
  GQ: [10.27, 1.65],
  GR: [21.82, 39.07],
  GS: [-36.59, -54.43],
  GT: [-90.23, 15.78],
  GU: [144.79, 13.44],
  GW: [-15.18, 12.00],
  GY: [-58.93, 4.86],
  HK: [114.11, 22.40],
  HM: [73.50, -53.08],
  HN: [-86.24, 15.20],
  HR: [15.20, 45.10],
  HT: [-72.29, 18.97],
  HU: [19.50, 47.16],
  ID: [113.92, -0.79],
  IE: [-8.24, 53.41],
  IL: [34.85, 31.05],
  IM: [-4.55, 54.24],
  IN: [78.96, 20.59],
  IO: [71.88, -6.34],
  IQ: [43.68, 33.22],
  IR: [53.69, 32.43],
  IS: [-19.02, 64.96],
  IT: [12.57, 41.87],
  JE: [-2.13, 49.21],
  JM: [-77.30, 18.11],
  JO: [36.24, 30.59],
  JP: [138.25, 36.20],
  KE: [37.91, -0.02],
  KG: [74.77, 41.20],
  KH: [104.99, 12.57],
  KI: [-168.73, 1.87],
  KM: [44.25, -12.17],
  KN: [-62.73, 17.36],
  KP: [127.51, 40.34],
  KR: [127.77, 35.91],
  KW: [47.48, 29.31],
  KY: [-80.57, 19.51],
  KZ: [66.92, 48.02],
  LA: [102.50, 19.86],
  LB: [35.86, 33.85],
  LC: [-60.98, 13.91],
  LI: [9.56, 47.17],
  LK: [80.77, 7.87],
  LR: [-9.43, 6.43],
  LS: [28.23, -29.61],
  LT: [23.88, 55.17],
  LU: [6.13, 49.82],
  LV: [24.60, 56.88],
  LY: [17.23, 26.34],
  MA: [-7.09, 31.79],
  MC: [7.41, 43.75],
  MD: [28.37, 47.41],
  ME: [19.37, 42.71],
  MF: [-63.05, 18.07],
  MG: [46.87, -18.77],
  MH: [171.18, 7.13],
  MK: [21.75, 41.51],
  ML: [-3.99, 17.57],
  MM: [95.96, 21.91],
  MN: [103.85, 46.86],
  MO: [113.54, 22.20],
  MP: [145.38, 17.33],
  MQ: [-61.02, 14.64],
  MR: [-10.94, 21.01],
  MS: [-62.19, 16.74],
  MT: [14.38, 35.94],
  MU: [57.55, -20.35],
  MV: [73.22, 3.20],
  MW: [34.30, -13.25],
  MX: [-102.55, 23.63],
  MY: [101.98, 4.21],
  MZ: [35.53, -18.67],
  NA: [18.49, -22.96],
  NC: [165.62, -20.90],
  NE: [8.08, 17.61],
  NF: [167.95, -29.04],
  NG: [8.68, 9.08],
  NI: [-85.21, 12.87],
  NL: [5.29, 52.13],
  NO: [8.47, 60.47],
  NP: [84.12, 28.39],
  NR: [166.93, -0.52],
  NU: [-169.87, -19.05],
  NZ: [174.89, -40.90],
  OM: [55.98, 21.51],
  PA: [-80.78, 8.54],
  PE: [-75.02, -9.19],
  PF: [-149.41, -17.68],
  PG: [143.96, -6.31],
  PH: [121.77, 12.88],
  PK: [69.35, 30.38],
  PL: [19.15, 51.92],
  PM: [-56.33, 46.94],
  PN: [-127.44, -24.70],
  PR: [-66.59, 18.22],
  PS: [35.23, 31.95],
  PT: [-8.22, 39.40],
  PW: [134.58, 7.51],
  PY: [-58.44, -23.44],
  QA: [51.18, 25.35],
  RE: [55.54, -21.12],
  RO: [24.97, 45.94],
  RS: [21.01, 44.02],
  RU: [105.32, 61.52],
  RW: [29.87, -1.94],
  SA: [45.08, 23.89],
  SB: [160.16, -9.64],
  SC: [55.49, -4.68],
  SD: [30.22, 12.86],
  SE: [18.64, 60.13],
  SG: [103.82, 1.35],
  SH: [-5.72, -15.97],
  SI: [14.99, 46.15],
  SJ: [23.67, 77.55],
  SK: [19.70, 48.67],
  SL: [-11.78, 8.46],
  SM: [12.46, 43.94],
  SN: [-14.45, 14.50],
  SO: [46.20, 5.15],
  SR: [-56.03, 3.92],
  SS: [31.31, 6.88],
  ST: [6.61, 0.19],
  SV: [-88.90, 13.79],
  SX: [-63.05, 18.04],
  SY: [38.99, 34.80],
  SZ: [31.47, -26.52],
  TC: [-71.80, 21.69],
  TD: [18.73, 15.45],
  TF: [69.35, -49.28],
  TG: [0.82, 8.62],
  TH: [100.99, 15.87],
  TJ: [71.28, 38.86],
  TK: [-172.12, -8.97],
  TL: [125.73, -8.87],
  TM: [59.56, 38.97],
  TN: [9.54, 33.89],
  TO: [-175.20, -21.18],
  TR: [35.24, 38.96],
  TT: [-61.22, 10.69],
  TV: [177.65, -7.11],
  TW: [120.96, 23.70],
  TZ: [34.89, -6.37],
  UA: [31.17, 48.38],
  UG: [32.29, 1.37],
  UM: [-160.07, 19.28],
  US: [-95.71, 37.09],
  UY: [-55.77, -32.52],
  UZ: [64.59, 41.38],
  VA: [12.45, 41.90],
  VC: [-61.19, 12.98],
  VE: [-66.59, 6.42],
  VG: [-64.64, 18.42],
  VI: [-64.90, 18.34],
  VN: [108.28, 14.06],
  VU: [166.96, -15.38],
  WF: [-176.18, -13.77],
  WS: [-172.10, -13.76],
  XK: [20.90, 42.60],
  YE: [48.52, 15.55],
  YT: [45.17, -12.83],
  ZA: [22.94, -30.56],
  ZM: [27.85, -13.13],
  ZW: [29.15, -19.02],
};
